import { getRuntimeEngine } from '@bymason/utils';
import { XrayRtcConnectionManager } from '../connection-manager';
import { XrayRtcConnectionInfo, XrayRtcConnectionOptions } from '../connection-manager/types';

const REPORT_INTERVAL_SECONDS = 10;
const TIMEOUT_SECONDS = 60 * 15; // 15-minutes

export interface XrayRemoteControlRtcConnectionOptions
  extends Omit<
    XrayRtcConnectionOptions,
    'feature' | 'onReport' | 'reportIntervalSeconds' | 'timeoutSeconds'
  > {
  onReport?: (stats: Omit<XrayRtcConnectionInfo, 'resetPendingTimeout'>) => void;
}

export class XrayRemoteControlRtcConnection extends XrayRtcConnectionManager {
  public constructor(options: XrayRemoteControlRtcConnectionOptions) {
    const runtimeEngine = getRuntimeEngine();

    if (runtimeEngine !== 'browser' && runtimeEngine !== 'webWorker') {
      // this is a show-stopper, so throw
      throw new Error(
        `Mason X-Ray Remote-Control client only supports browser environments (i.e. NodeJS is not currently supported)`
      );
    }

    super({
      ...options,
      feature: 'remote-control',
      reportIntervalSeconds: REPORT_INTERVAL_SECONDS,
      timeoutSeconds: TIMEOUT_SECONDS,
    });
  }
}
